/* import React from "react";
import { Box, Container, Divider, Paper, Typography } from "@mui/material";

import GavelIcon from "@mui/icons-material/Gavel";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import PaymentsIcon from "@mui/icons-material/Payments";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PersonIcon from "@mui/icons-material/Person";
import "./TermsStyle.css";

function TermsConditions() {

    const sections = [
        {
            icon: <GavelIcon sx={{ color: "#f5b600", fontSize: 35 }} />,
            title: "Privacy Policy",
            description: `Welcome to SDHR InnoWorks Private Limited. By accessing our website or purchasing products from us, you agree to comply with the following Terms & Conditions. Please read these terms carefully before placing an order. These policies are designed to provide a transparent shopping experience while protecting both our customers and our business.`
        },
        {
            icon: <Inventory2Icon sx={{ color: "#f5b600", fontSize: 35 }} />,
            title: "Products",
            description: `We manufacture and sell premium-quality cane furniture for homes, offices, hotels, resorts, restaurants, balconies, gardens, and outdoor spaces. Every product is handcrafted with care. Due to the natural characteristics of cane and wood, slight variations in color, texture, polish, or finish may occur. These natural differences are not considered manufacturing defects.`
        },
        {
            icon: <PaymentsIcon sx={{ color: "#f5b600", fontSize: 35 }} />,
            title: "Pricing & Payments",
            description: `All prices displayed on our website are in Indian Rupees (INR). Applicable taxes and shipping charges, if any, will be calculated during checkout. Orders are confirmed only after successful payment verification. We reserve the right to update product prices without prior notice.`
        },
        {
            icon: <LocalShippingIcon sx={{ color: "#f5b600", fontSize: 35 }} />,
            title: "Shipping Overview",
            description: `We deliver furniture across India through trusted logistics partners. Delivery time depends on your location and product availability. Large furniture items may require additional transit time. Customers will receive order updates through email or phone once the order has been dispatched.`
        },
        {
            icon: <PersonIcon sx={{ color: "#f5b600", fontSize: 35 }} />,
            title: "Customer Responsibilities",
            description: `Customers are requested to provide accurate billing and shipping information while placing orders. Please inspect the package carefully at the time of delivery. Any visible damage or missing items should be reported immediately to our support team. Incorrect addresses or unavailable recipients may result in delivery delays or additional shipping charges.`
        }
    ];

    return (
        <Box className="termsMain">


            <Box className="termsBanner">

                <Container maxWidth="lg">
                    <Typography variant="h3" className="bannerTitle" color={"#f5b600"}>Privacy Policy</Typography>
                    <Typography className="bannerSubTitle">SDHR InnoWorks Private Limited</Typography>
                </Container>

            </Box>

            <Container maxWidth="lg">
                <Paper elevation={3} className="companyCard">

                    <Typography variant="h5" sx={{ color: "#f5b600", fontWeight: "bold", mb: 2 }}>Company Information</Typography>
                    <Divider sx={{ mb: 3 }} />

                    <Typography sx={{ mb: 1 }}>
                        <strong>Company Name:</strong> SDHR InnoWorks Private Limited
                    </Typography>

                    <Typography sx={{ mb: 1 }}>
                        <strong>Address:</strong>
                    </Typography>

                    <Typography>9/25/1 K K GUNTA,</Typography>

                    <Typography>YERPEDU,</Typography>

                    <Typography>Thondamanadu,Srikalahasti,</Typography>

                    <Typography>Chittoor - 517641, Andhra Pradesh, India.</Typography>
                </Paper>


                {
                    sections.map((item, index) => (
                        <Paper elevation={2} key={index} className="policyCard">
                            <Box className="policyHeader">
                                {item.icon}
                                <Typography variant="h5" sx={{ ml: 2, fontWeight: "bold" }}>{item.title}</Typography>
                            </Box>
                            <Divider sx={{ my: 2 }} />
                            <Typography className="policyText">{item.description}</Typography>
                        </Paper>
                    ))
                }
            </Container>

            <Paper elevation={2} mx={"md"} className="policyCard" Container width="md">

                <Typography variant="h5" sx={{ color: "#f5b600", fontWeight: "bold" }}>Refund Policy</Typography>

                <Divider sx={{ my: 2 }} />

                <Typography className="policyText" paragraph>
                    At <strong>SDHR InnoWorks Private Limited</strong>, customer satisfaction is our highest priority.
                    If you receive a damaged, defective, or incorrect product, you may request a refund subject
                    to our verification process.
                </Typography>
                <Typography className="policyText" paragraph>• Refund requests must be submitted with clear photos or videos of the product.</Typography>
                <Typography className="policyText" paragraph>• After our quality inspection and approval, the refund will be initiated.</Typography>
                <Typography className="policyText" paragraph>• The refund amount will be credited to your original payment method within<strong> 4 to 5 working days </strong>after approval.</Typography>
                <Typography className="policyText">• Shipping charges are non-refundable unless the mistake occurred from our side.</Typography>

            </Paper>

            <Paper elevation={2} className="policyCard">

                <Typography variant="h5" sx={{ color: "#f5b600", fontWeight: "bold" }}>Return Policy</Typography>

                <Divider sx={{ my: 2 }} />

                <Typography className="policyText" paragraph>
                    Customers may request a return within
                    <strong> 7 working days </strong>
                    from the date of delivery if:
                </Typography>

                <Typography className="policyText" paragraph>• The product is damaged during transportation.</Typography>
                <Typography className="policyText" paragraph>• The wrong product has been delivered.</Typography>
                <Typography className="policyText" paragraph>• The product has a verified manufacturing defect.</Typography>
                <Typography className="policyText">Returned items must be unused, in their original packaging, with all accessories and invoice included.</Typography>

            </Paper>


            <Paper elevation={2} className="policyCard">

                <Typography variant="h5" sx={{ color: "#f5b600", fontWeight: "bold" }}>Replacement Policy</Typography>

                <Divider sx={{ my: 2 }} />

                <Typography className="policyText" paragraph>If you receive a damaged or defective product, you may request a replacement.</Typography>

                <Typography className="policyText" paragraph>
                    Replacement requests must be raised within
                    <strong> 3 to 4 working days </strong>
                    from the delivery date.
                </Typography>

                <Typography className="policyText" paragraph>
                    After our verification, the replacement product will be dispatched as soon as possible,
                    depending on product availability.
                </Typography>

                <Typography className="policyText">
                    Customized or specially manufactured furniture may not be eligible for replacement
                    unless there is a manufacturing defect.
                </Typography>

            </Paper>


            <Paper elevation={2} className="policyCard">
                <Typography variant="h5" sx={{ color: "#f5b600", fontWeight: "bold" }}>Shipping Policy</Typography>

                <Divider sx={{ my: 2 }} />

                <Typography className="policyText" paragraph>We deliver furniture across India through reliable logistics partners.</Typography>
                <Typography className="policyText" paragraph>• Orders are usually dispatched within 1–3 business days after payment confirmation.</Typography>
                <Typography className="policyText" paragraph>• Delivery timelines depend upon customer location and courier availability.</Typography>
                <Typography className="policyText" paragraph>• Large furniture items may require additional shipping time.</Typography>
                <Typography className="policyText">• Customers will receive tracking details once the order has been dispatched.</Typography>

            </Paper>

            

            <Paper elevation={2} className="policyCard" sx={{ p: 4, mt: 4, borderRadius: 3 }}>

                <Typography variant="h5" sx={{ color: "#f5b600", fontWeight: "bold" }}>Cancellation Policy</Typography>

                <Divider sx={{ my: 2 }} />

                <Typography className="policyText" paragraph>
                    Orders can be cancelled before they are dispatched from our warehouse.
                </Typography>

                <Typography className="policyText" paragraph>
                    Once the order has been shipped, cancellation requests cannot be accepted.
                </Typography>

                <Typography className="policyText">
                    If an eligible cancellation is approved, the refund will be processed according to our Refund Policy.
                </Typography>

            </Paper>

            

            <Paper elevation={4} sx={{ mt: 5, mb: 5, p: 4, bgcolor: "#111", color: "white", borderRadius: 3 }}>
                <Typography variant="h4" sx={{ color: "#f5b600", fontWeight: "bold", mb: 3 }}>Contact Us</Typography>
                <Typography sx={{ mb: 1 }}>
                    <strong>Company:</strong> SDHR InnoWorks Private Limited
                </Typography>

                <Typography sx={{ mb: 1 }}>
                    <strong>Address:</strong>
                </Typography>

                <Typography>9/25/1 K K GUNTA,</Typography>

                <Typography>YERPEDU,</Typography>

                <Typography>Thondamanadu, Srikalahasti,</Typography>

                <Typography>
                    Chittoor - 517641,
                    Andhra Pradesh,
                    India.
                </Typography>

                <Typography sx={{ mt: 3 }}>
                    <strong>Email:</strong> sdhrinnoworks@gmail.com
                </Typography>

                <Typography>
                    <strong>Business Hours:</strong> 9:00 AM – 8:00 PM (All Days)
                </Typography>

            </Paper>
        </Box>
    );

}

export default TermsConditions; */


import React from "react";
import { Box, Container, Paper, Typography, Divider } from "@mui/material";

const TermsConditions = () => {
    return (
        <Box sx={{ py: 5, background: "#fafafa" }}>
            <Container maxWidth="md">

                <Typography
                    variant="h3"
                    fontWeight="bold"
                    align="center"
                    color="#f5b600"
                    gutterBottom
                >
                    Terms & Conditions
                </Typography>

                <Paper sx={{ p: 4, borderRadius: 3 }}>

                    <Typography paragraph>
                        Welcome to <strong>SDHR InnoWorks Private Limited</strong>.
                        By accessing our website and purchasing our products,
                        you agree to the following Terms & Conditions.
                    </Typography>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="h5" gutterBottom>
                        1. Products
                    </Typography>

                    <Typography paragraph>
                        All furniture products are handcrafted using premium-quality
                        cane and wood. Slight variations in color, texture, polish,
                        and finish are natural and are not considered manufacturing defects.
                    </Typography>

                    <Typography variant="h5" gutterBottom>
                        2. Pricing
                    </Typography>

                    <Typography paragraph>
                        All prices are displayed in INR and include applicable taxes
                        unless otherwise mentioned. Shipping charges, if applicable,
                        are calculated during checkout.
                    </Typography>

                    <Typography variant="h5" gutterBottom>
                        3. Orders
                    </Typography>

                    <Typography paragraph>
                        Orders are confirmed only after successful payment. We reserve
                        the right to cancel or refuse any order due to pricing errors,
                        stock availability, or suspected fraudulent activity.
                    </Typography>

                    <Typography variant="h5" gutterBottom>
                        4. Shipping
                    </Typography>

                    <Typography paragraph>
                        Delivery timelines depend upon customer location and courier
                        availability. Delays caused by logistics partners or natural
                        events are beyond our control.
                    </Typography>

                    <Typography variant="h5" gutterBottom>
                        5. Customer Responsibilities
                    </Typography>

                    <Typography paragraph>
                        Customers must provide accurate delivery details and inspect
                        the package upon delivery. Any visible damage should be
                        reported immediately.
                    </Typography>

                    <Typography variant="h5" gutterBottom>
                        6. Intellectual Property
                    </Typography>

                    <Typography paragraph>
                        All images, logos, product descriptions, and website content
                        belong to SDHR InnoWorks Private Limited and may not be copied
                        without written permission.
                    </Typography>

                    <Typography variant="h5" gutterBottom>
                        7. Limitation of Liability
                    </Typography>

                    <Typography paragraph>
                        We are not liable for indirect or consequential damages arising
                        from the use of our products or services.
                    </Typography>

                    <Typography variant="h5" gutterBottom>
                        8. Contact
                    </Typography>

                    <Typography>Email: sdhrinnoworks@gmail.com</Typography>
                    <Typography>Mobile. No.: +91 9347566010</Typography>

                </Paper>

            </Container>
        </Box>
    );
};

export default TermsConditions;